
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["lucide lucide-notes",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.5 1.75h8.1a1 1 0 01.77.37l1.88 2.25a1 1 0 01.25.45v9.38a1 1 0 01-1 1h-10a1 1 0 01-1-1v-12a1 1 0 011-1z"}}),_c('path',{attrs:{"d":"M10.85 1.75h2.4a1 1 0 011 1V5.3M4.75 5.25h6.5M4.75 7.75h5.8M4.75 10.25h5.2M4.75 12.75h3.6"}})])
          )
        }
      }
    